import { ColumnType } from "../../query/visual/types";

// AID supports an additional type for unix timestamps. This is not added to the base ColumnType because
// it has no effect on the query that is built or run. This casting is more of a notice to the recommender
// to treat these features as timestamps rather than floats.
export const FM_COLUMN_TYPE_UNIX_TIMESTAMP = "unixTimestamp" as const;

export const FM_COLUMN_TYPES = [
  ...Object.values(ColumnType),
  FM_COLUMN_TYPE_UNIX_TIMESTAMP,
];
export type FMColumnType = (typeof FM_COLUMN_TYPES)[number];
